import { Table } from '@tanstack/react-table';

import { DataTableColumnsSelector } from '@/components/data-table/data-table-columns-selector';
import {
  DataTableFiltersV2,
  TableFilterConfig,
  UseTableFiltersReturn,
} from '@/components/data-table/filters-v2';
import {
  DateRangePickerV2,
  DateRangePreset,
  DateRangeV2,
} from '@/modules/common/components/molecules/date/date-range-picker-v2';

import { TIME_OFF_APPROVALS_TABLE_ID } from '../../constants/time-off-approvals-filter-keys';
import { TimeOffRequest } from '../../types/time-off-request';

interface TimeOffApprovalsToolbarProps {
  filtersConfig: TableFilterConfig[];
  filterState: UseTableFiltersReturn;
  dates: DateRangeV2 | null;
  selectedPreset: DateRangePreset | null;
  onDateChange: (next: DateRangeV2) => void;
  onPresetSelect: (preset: DateRangePreset) => void;
  onDateReset: () => void;
  table: Table<TimeOffRequest>;
}

/**
 * Filters + columns row for the approvals table. Rendered as a static (shrink-0)
 * row above the table — the table itself owns vertical scroll (fixedHeight), so the
 * toolbar never needs sticky positioning.
 */
export const TimeOffApprovalsToolbar = ({
  filtersConfig,
  filterState,
  dates,
  selectedPreset,
  onDateChange,
  onPresetSelect,
  onDateReset,
  table,
}: TimeOffApprovalsToolbarProps) => {
  return (
    <div className="mb-4 flex shrink-0 items-start justify-between gap-2 pt-1">
      <div className="flex flex-wrap items-center gap-2">
        <DataTableFiltersV2
          filtersConfig={filtersConfig}
          filterState={filterState}
          tableId={TIME_OFF_APPROVALS_TABLE_ID}
          showSaveButton={false}
        />
        <DateRangePickerV2
          dates={dates}
          onChange={onDateChange}
          onPresetSelect={onPresetSelect}
          selectedPreset={selectedPreset}
          onReset={onDateReset}
        />
      </div>
      <DataTableColumnsSelector table={table} />
    </div>
  );
};
